// extracted by mini-css-extract-plugin
module.exports = {"header":"SignIn_header__1snqe","row":"SignIn_row__LsMd6","footer":"SignIn_footer__7xKnw","formFooter":"SignIn_formFooter__2mvWp"};